/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

import {
    getLang,
    getLoader,
    toggleFormButtons,
    setTabContentHeight
} from './main.js';
import {
    setWidgetMode,
    setPlainMode,
    isSourceMode,
    isPlainMode,
    loadContent,
    preloadContentDropdown
} from './grid.js';

export function installDemoData() {
    let loadDemoContent = function () {
        ddh.confirm(ddh.translate('DD_VISUAL_EDITOR_LOAD_DEMODATA_INFO'), function () {
            $.get(window.VisualEditorInstance.options.actionLink + '&fnc=searchContents&editlanguage=' + getLang() + '&block=0&ident=oxdemopage', function (data) {
                if (data && data.length) {
                    preloadContentDropdown(data[0].id);
                }
            });
        });
    };

    let $action = $(this);
    if ($action.hasClass('hasDemodata')) {
        loadDemoContent();
    } else {
        let demodataControllerUrl = document.getElementById('demodata-button-block').dataset.url;

        $action.html('<i class="fa-solid fa-spinner"></i>');
        $action.prop('disabled', true);
        $.get(demodataControllerUrl + '&fnc=installDemodata&editlanguage=' + getLang() + '&module=' + $action.data('module'), function (res) {
            $action.prop('disabled', false);
            if (res && res.success) {
                $action.addClass('hasDemodata');
                $action.html(ddh.translate('DD_VISUAL_EDITOR_LOAD_DEMODATA'));
                loadDemoContent();
            }
        });
    }
}

$('.dd-delete-action').on('click', function (e) {
    e.preventDefault();

    ddh.confirm(ddh.translate('DD_VISUAL_EDITOR_DELETE_CONFIRM'), function () {
        $('#myedit').submit();
        loadContent.call(this, null);
    });
});

$('.btn-preview').on('click', function (e) {
    e.preventDefault();

    document.querySelector('form#myedit').fnc.value = 'savePreview';
    document.querySelector('#previewModal').setAttribute('data-target', '#myedit');

    $('#previewModal').modal('show');
});

// Save content
$('#myedit').on('submit', function (e) {
    e.preventDefault();

    toggleFormButtons(false);
    getLoader().show();
    let self = this;
    let data = $(this).serialize();

    if (isSourceMode()) {
        data += '&source=' + encodeURIComponent($('.dd-veditor-source textarea').val());
    } else {
        $.each(window.VisualEditorInstance.serialize(), function () {
            data += '&widget[' + this.row + '][' + this.col + ']=' + encodeURIComponent(JSON.stringify(this));
        });
    }
    data += '&editlanguage=' + getLang();
    $.post($(this).attr('action'), data, function (data) {
        let savedEvent = $.Event('saved.ve.content');
        $(self).trigger(savedEvent, [data]);
        if (savedEvent.isDefaultPrevented()) {
            toggleFormButtons(true);
            return;
        }

        if (data.error) {
            toggleFormButtons(true);
            ddh.alert(data.msg);
            getLoader().hide();
            return;
        }

        if (!data.url) {
            if (!data.id) {
                toggleFormButtons(true);
                preloadContentDropdown();
                getLoader().hide();
                return;
            }
            let _setActiveContent = function () {
                if (data['new']) { /* make jshint happy*/
                    $('input#elm_edit_new').prop('checked', false).change();
                }
                preloadContentDropdown(data.id);
            };

            if (isPlainMode()) {
                setPlainMode(_setActiveContent);
            } else {
                setWidgetMode(_setActiveContent);
            }
        }
    });
});

// Timespan activation
export function timeStampActivate() {
    let $timespan = $('.dd-veditor-timespan');
    if ($timespan.is(':visible')) {
        $timespan.hide();
        $(this).html(ddh.translate('DD_VISUAL_EDITOR_ACTIVE_TIMESPAN_SELECT'));
    } else {
        $timespan.show();
        $(this).html(ddh.translate('DD_VISUAL_EDITOR_ACTIVE_TIMESPAN_HIDE'));
    }

    setTabContentHeight();
}

// Block assignments
$('.dd-block-picker').change(function () {
    if ($(this).val() !== '') {
        $('.dd-cms-object-type').show();
    } else {
        $('.dd-cms-object-type').hide();
    }

    let sObjectType = $('.dd-block-object-picker').val();
    if (sObjectType) {
        if (sObjectType !== 'empty') {
            let $activeObjectElement = $('.dd-cms-object-id:visible select');
            if ($activeObjectElement.length && $activeObjectElement[0].selectize) {
                $activeObjectElement[0].selectize.setValue($activeObjectElement.val());
            }
        } else {
            $('.dd-block-object-picker').trigger('change');
        }
    }
});

$('.dd-block-object-picker').change(function () {
    if ($(this).val() === 'empty') {
        let sLang = $('#elm_lang').val();
        let sBlock = $('#elm_edit_block').val();
        $.get(VE.options.actionLink + '&fnc=searchBlock&editlanguage=' + sLang + '&block=' + sBlock + '&objecttype=empty', function (data) {
            if (data && data.id) {
                $('.dd-delete-block-action').removeAttr('disabled');
            } else {
                $('.dd-delete-block-action').attr('disabled', true);
            }
            loadContent.call(this, data);
        });
    } else {
        if ($(this).val() !== '') {
            $('.dd-cms-object-id select').each(function () {
                this.selectize.setValue('');
            });
        } else {
            loadContent();
        }
    }
});
